var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapperElement",staticClass:"modal wrapper"},[_c('transition',{attrs:{"name":"modal"}},[_vm._t("default",null,{"closeModal":_vm.close})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }